export default __webpack_public_path__ + "static/media/radiant-bright-blue-green.1ea4418a.jpg";